<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="11">
        <v-row
          justify="space-between"
          align="center"
        >
          <v-col cols="auto">
            <h2> Unions </h2>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="primary"
              :to="{name:'unions-create'}"
              data-cy="unions-table-btn-add"
            >
              Create Union
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="unions"
          :options.sync="options"
          :loading="loading"
          :items-per-page="5"
          show-expand
          :footer-props="{'items-per-page-options':[5, 10, 25]}"
          :server-items-length="serverCount"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              clearable
              prepend-inner-icon="mdi-magnify"
              class="mx-4"
              @input="getData()"
            ></v-text-field>
          </template>
          <template v-slot:expanded-item="{ item }">
            <td
              class="py-3"
              colspan="4"
            >
              <h3>{{ `${item.name}` }} <v-btn
                    icon
                    :to="{name: 'union-edit', params: {unionId: item.id}}"
                  >
                    <v-icon> mdi-wrench </v-icon>
                  </v-btn>
                  <v-dialog
                    v-model="deleteUnionDialog"
                    width="500"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                      >
                        <v-icon> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        Are you sure you want to delete this Union?
                      </v-card-title>
                      <v-card-actions>
                        <v-row justify="end">
                          <v-col cols="auto">
                            <v-btn
                              text
                              @click="() => deleteUnionDialog = false"
                            >
                              CANCEL
                            </v-btn>
                          </v-col>
                          <v-col cols="auto">
                            <v-btn
                              color="error"
                              text
                              @click="deleteUnion(item.id)"
                            >
                              DELETE
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
              </h3>
              <v-row
                no-gutters
                wrap
              >
                <v-cols
                  cols="12"
                  class="mb-4"
                  md="4"
                >
                  <v-card
                    flat
                    tile
                    class="pa-2"
                  >
                    <v-row no-gutters>
                      <v-col cols="12">
                        <b> Alternate Name: </b> {{ item.alternateName }}
                      </v-col>
                      <v-col
                        v-if="item.market"
                        cols="12"
                      >
                        <b> Markets: </b>
                        <div
                          v-for="(market, i) in item.market"
                          :key="i"
                        >
                          {{ market.name }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-cols>
              </v-row>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getUnionSearch, deleteUnion } from '../services/unions';

export default {
  data() {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Alt Name', align: 'start', value: 'alternateName' },
        // { text: 'Market', align: 'start', value: 'market.name' },
      ],
      unions: [],
      rowsPerPageItems: [5, 10, 10],
      options: {},
      loading: false,
      serverCount: 0,
      search: '',
      deleteUnionDialog: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      const { data } = await getUnionSearch(this.search, this.options?.page, this.options?.itemsPerPage);
      console.log(this.options);
      console.log(data);
      this.serverCount = data?.count;
      this.unions = data?.results;
      this.loading = false;
    },
    async deleteUnion(id) {
      await deleteUnion(id);
      await this.getData();
    },
  },
};
</script>

<style>

</style>
